import { DescripcionNota } from '../../../shared/interfaces/descripcion.interface';
import { AgregarPersonaAntecedentesIglesia } from '../agregar-persona-form.interface';

export function buildAntecedentesNotaText(data: AgregarPersonaAntecedentesIglesia): string {
  const partes: string[] = [];

  if (data.ibaIglesia) {
    const iglesia = data.iglesiaAnterior.trim();
    const tiempo = data.tiempoIglesia.trim();
    partes.push(`Esta persona iba a ${iglesia}, asistió durante ${tiempo}`);

    if (data.aceptoJesus) {
      partes.push('ya aceptó a Jesús en su corazón');
    } else {
      partes.push('aún no aceptó a Jesús en su corazón');
    }
  } else {
    partes.push('Esta persona no iba a una iglesia antes');
  }

  if (data.bautizado) {
    partes.push('está bautizada');
  } else {
    partes.push('no está bautizada');
  }

  if (partes.length === 1) {
    return `${partes[0]}.`;
  }

  const inicio = partes.slice(0, -1).join(', ');
  return `${inicio} y ${partes[partes.length - 1]}.`;
}

export function createDescripcionNotaSistema(
  nota: string,
  autor: string,
  now = new Date(),
): DescripcionNota {
  return {
    _id: createObjectIdHex(),
    nota,
    hora: formatHora(now),
    fecha: formatFecha(now),
    autor: autor.trim() || 'sistema',
    tipo: 'sistema',
    leido: false,
  };
}

export function buildAntecedentesDescripcionNota(
  data: AgregarPersonaAntecedentesIglesia,
  autor: string,
  now = new Date(),
): DescripcionNota {
  return createDescripcionNotaSistema(buildAntecedentesNotaText(data), autor, now);
}

/** Mensaje de alta: quién agregó a la persona y, si hay, los antecedentes de iglesia. */
export function buildAltaSistemaNota(input: {
  autorNombre: string;
  autorApellido: string;
  antecedentes: AgregarPersonaAntecedentesIglesia | null;
  now?: Date;
}): DescripcionNota {
  const autor = `${input.autorNombre} ${input.autorApellido}`.trim();
  const quien = `Persona agregada a Mayorap por ${autor.toUpperCase()}`;
  const detalle = input.antecedentes ? buildAntecedentesNotaText(input.antecedentes) : '';
  const nota = detalle ? `${quien}. ${detalle}` : `${quien}.`;
  return createDescripcionNotaSistema(nota, autor, input.now);
}

function formatFecha(date: Date): string {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

function formatHora(date: Date): string {
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
}

function createObjectIdHex(): string {
  const bytes = new Uint8Array(12);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
}
